import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=3c4bd182&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4bd182')) {
      api.createRecord('3c4bd182', component.options)
    } else {
      api.reload('3c4bd182', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=3c4bd182&", function () {
      api.rerender('3c4bd182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24UxzxdjyieTj/JS/cancellationPolicy.vue"
export default component.exports